<template>
  <EmptyStateOfferCard
    :interest-rate="interestRate"
    :installment-value="cptdInstallmentValue"
    :duration="duration"
    :amount="amount"
    :icon-name="cptdProductIcon"
    :custom-leading-caption="product === 'FGTS' ? 'Descontado do FGTS' : ''"
    @action-forward-click="$router.push({ path: formPath, query: formQuery })"
    @offer-conditions-click="$router.push({ path: formPath, query: formQuery })"
    @brand-click="$router.push({ path: formPath, query: formQuery })"
  />
</template>
<script>
import { parseToBRL, parseToDecimal } from '@/helpers/currency'
import { calculateLoanInstallments } from '@/helpers/calculations'
import EmptyStateOfferCard from '~/aasgard/components/cards/EmptyStateOfferCard.vue'

export default {
  name: 'ProductEmptyStateOfferCard',
  components: {
    EmptyStateOfferCard,
  },
  props: {
    amount: { type: Number, required: true },
    duration: { type: [Number, String], required: true },
    interestRate: { type: Number, required: true },
    product: { type: String, required: true },
    formPath: { type: String, required: true },
    formQuery: { type: Object, default: () => ({}) },
  },
  computed: {
    cptdInstallmentValue() {
      return Number(
        calculateLoanInstallments(
          this.interestRate / 100,
          this.amount,
          this.duration,
          true,
        ),
      )
    },
    cptdLabelInstallment() {
      return `${this.duration}x de ${parseToBRL(this.cptdInstallmentValue)}`
    },
    cptdProductIcon() {
      const productIconsMap = {
        NO_COLLATERAL: 'hand-money-mono',
        AUTO_EQUITY: 'car-money-mono',
        MOTORCYCLE_EQUITY: 'moto-money-mono',
        TRUCK_EQUITY: 'car-money-mono',
        MOBILE_EQUITY: 'smartphone-mono',
        HOME_EQUITY: 'home-money-mono',
        CREDIT_CARD_EQUITY: 'credit-card-mono',
        PAYROLL: 'hand-money-mono',
        FGTS: 'hand-money-mono',
      }

      return productIconsMap[this.product] ?? ''
    },
  },
  methods: {
    parseToDecimal,
    calculateLoanInstallments,
    parseToBRL,
  },
}
</script>
<style lang="scss"></style>
